import React from 'react';

import css from './AnnouncementBar.module.css';

export default function AnnouncementBar() {
  return (
    <div className={css.announcementBarContainer}>
      <a href="/">
        <p className={css.message}>Welcome to Gearly</p>
      </a>
    </div>
  );
}